import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./styles.css";
//internal and external component imports
import ClubCards from "../../components/ClubCards";
// import { clubDetails } from "../../assets/staticData";
import MyClubsTable from "../../components/MyClubsTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard, faTable, faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { colors } from "../../common/pallette/colors";
import { getClubs, getLeagues, managePinnedClubs } from "../../api/common";
import ClubCardsSkeleton from "../../components/ClubCardsSkeleton";
import {
  setDisplayMyClubs,
  setPinnedClubs,
  setMyClubs,
  setLeagues,
} from "../../redux/reducers/common";
import MessageModalPopup from "../../components/MessageModalPopup/index.tsx";
import useWindowSize from "../../hooks/useWindowSize";
import { screenResolution } from "../../common/StaticExports";

const MyClubsContainer = () => {
  const { width } = useWindowSize();
  const [view, setView] = useState("tableView");
  const searchString = useSelector(
    (state: any) => state.common.adminPageSearchString
  );
  const myClubs = useSelector((state: any) => state.common.myClubs);
  const displayMyClubs = useSelector(
    (state: any) => state.common.displayMyClubs
  );
  const pinnedClubs = useSelector((state: any) => state.common.pinnedClubs);
  const clubNameFilter = useSelector(
    (state: any) => state.common.clubNameFilter
  );
  const leagueFilter = useSelector((state: any) => state.common.leagueFilter);
  const starsFilter = useSelector(
    (state: any) => state.common.starRatingFilter
  );
  const targetStarsFilter = useSelector(
    (state: any) => state.common.targetStarRatingFilter
  );
  const [isfetchingClubs, setIsFetchingClubs] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let filteredClubs = myClubs ? myClubs : [];

    if (searchString !== "") {
      filteredClubs = filteredClubs.filter((club: any) =>
        club.name.toLowerCase().includes(searchString.toLowerCase())
      );
    }

    if (clubNameFilter && clubNameFilter.length > 0) {
      filteredClubs = filteredClubs.filter((d: any) =>
        clubNameFilter.some((obj: any) => d.id == obj.id)
      );
    }

    if (leagueFilter && leagueFilter.length > 0) {
      filteredClubs = filteredClubs.filter((d: any) =>
        leagueFilter.some((obj: any) => d.leagueId == obj.id)
      );
    }

    if (starsFilter && starsFilter.length > 0) {
      filteredClubs = filteredClubs.filter((d: any) =>
        starsFilter.some((obj: any) => d.currentRating == obj.id)
      );
    }

    if (targetStarsFilter && targetStarsFilter.length > 0) {
      filteredClubs = filteredClubs.filter((d: any) =>
        targetStarsFilter.some((obj: any) => d.targetRating == obj.id)
      );
    }

    dispatch(setDisplayMyClubs(filteredClubs));
    const tempArr = filteredClubs.filter((d: any) => d.isPinned);
    dispatch(setPinnedClubs(tempArr));
  }, [
    searchString,
    myClubs,
    clubNameFilter,
    leagueFilter,
    starsFilter,
    targetStarsFilter,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsFetchingClubs(true);
        const response = await getClubs();
        const leagues = await getLeagues();
        dispatch(setLeagues(leagues));
        // dispatch(getMyClubs(response));
        // setClubDetails(response);
        // if (response !== undefined && response.length) {
        //     favouriteClubs = response.filter((d: any) => d.isFavourite);
        // }
        return response;
      } catch {
        console.error("error in fetching club data");
      }
    };
    myClubs.length == 0 &&
      fetchData().then((res) => {
        dispatch(setMyClubs(res));
        dispatch(setDisplayMyClubs(res));
        const tempArr = res?.filter((d: any) => d.isPinned);
        dispatch(setPinnedClubs(tempArr));
        setIsFetchingClubs(false);
      });
  }, []);

  const pinClub = async (clubId: any) => {
    const response = await managePinnedClubs({ clubId: clubId });
    return response;
  };

  const manageIsPinnedClick = (data: any) => {
    if (pinnedClubs.length < 10 || data.isPinned) {
      pinClub(data.id)
        .then(() => {
          let tempData = { ...data, isPinned: !data.isPinned };
          let index = myClubs.findIndex((x: any) => x.id == data.id);
          let updatedClubDetails: any = [...myClubs];
          updatedClubDetails.splice(index, 1, tempData);
          dispatch(setMyClubs(updatedClubDetails));
        })
        .catch((err) => console.error(err));
    } else if (pinnedClubs.length == 10) {
      setOpenPopup(true);
    }
  };

  return (
    <React.Fragment>
      <Box className="myClubsDetails" sx={{ borderColor: colors.grey.bright }}>
        {openPopup && (
          <MessageModalPopup
            open={openPopup}
            message={"Reached the maximum limit of pinned clubs."}
            closeModal={() => {
              setOpenPopup(false);
            }}
          />
        )}

        {/* ── Heading with result count ── */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', mb: '4px' }}>
          <Typography className="collapseHeading" sx={{ mb: '0 !important' }}>MY CLUBS</Typography>
          {/* Count badge: shows total matching clubs when search is active */}
          {searchString !== '' && (
            <Box
              sx={{
                fontSize: '10px',
                fontWeight: 600,
                px: '7px',
                py: '1px',
                borderRadius: '20px',
                backgroundColor: displayMyClubs?.length > 0 ? `${colors.blue.navy}15` : 'rgba(224,68,68,0.10)',
                color: displayMyClubs?.length > 0 ? colors.blue.navy : '#D94040',
                border: `1px solid ${displayMyClubs?.length > 0 ? `${colors.blue.navy}30` : 'rgba(217,64,64,0.25)'}`,
                transition: 'all 0.2s',
                whiteSpace: 'nowrap',
              }}
            >
              {displayMyClubs?.length ?? 0} {displayMyClubs?.length === 1 ? 'club' : 'clubs'}
            </Box>
          )}
        </Box>

        {/* ── Full-height flex column: pinned → separator → all-clubs ── */}
        <Box className="myClubsContentWrapper">

          {/* ── Pinned cards grid ── */}
          <Box className="myClubCardsContainer">
            {isfetchingClubs ? (
              Array.from({ length: 10 }, (_, i) => <ClubCardsSkeleton key={i} />)
            ) : pinnedClubs && pinnedClubs.length ? (
              pinnedClubs.map((club: any) => (
                <ClubCards key={club.id} data={club} manageIsPinnedClick={manageIsPinnedClick} />
              ))
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', py: '4px', opacity: 0.55 }}>
                <FontAwesomeIcon icon={faAddressCard} style={{ fontSize: '13px', color: colors.grey.dark }} />
                <Typography sx={{ fontSize: '11px', color: colors.grey.dark }}>
                  {searchString ? 'No pinned clubs match your search' : 'No clubs pinned yet'}
                </Typography>
              </Box>
            )}
          </Box>

          {/* ── Separator: full-width rule + view-toggle icons ── */}
          <Box sx={{ display: 'flex', alignItems: 'center', mt: '14px', mb: '10px', flexShrink: 0 }}>
            <Divider sx={{ flex: 1, borderColor: colors.grey.bright, borderBottomWidth: 2 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', pl: '10px' }}>
              <Tooltip title="Cards View" arrow placement="top">
                <Box
                  onClick={() => setView("cardView")}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '28px',
                    height: '28px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    backgroundColor: view === "cardView" ? colors.blue.navy : 'transparent',
                    border: `1px solid ${view === "cardView" ? colors.blue.navy : colors.grey.bright}`,
                    transition: 'all 0.15s',
                    '&:hover': {
                      backgroundColor: view === "cardView" ? colors.blue.navy : `${colors.blue.navy}10`,
                      borderColor: colors.blue.navy,
                    },
                  }}
                >
                  <FontAwesomeIcon
                    icon={faAddressCard}
                    style={{ fontSize: '13px', color: view === "cardView" ? '#fff' : colors.grey.dark }}
                  />
                </Box>
              </Tooltip>
              <Tooltip title="Table View" arrow placement="top">
                <Box
                  onClick={() => setView("tableView")}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '28px',
                    height: '28px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    backgroundColor: view === "tableView" ? colors.blue.navy : 'transparent',
                    border: `1px solid ${view === "tableView" ? colors.blue.navy : colors.grey.bright}`,
                    transition: 'all 0.15s',
                    '&:hover': {
                      backgroundColor: view === "tableView" ? colors.blue.navy : `${colors.blue.navy}10`,
                      borderColor: colors.blue.navy,
                    },
                  }}
                >
                  <FontAwesomeIcon
                    icon={faTable}
                    style={{ fontSize: '13px', color: view === "tableView" ? '#fff' : colors.grey.dark }}
                  />
                </Box>
              </Tooltip>
            </Box>
          </Box>

          {/* ── All-clubs section: fills every remaining pixel ── */}
          {/* Table view: overflow hidden so TableContainer owns its own scroll with sticky header */}
          {/* Card view: overflow auto so the grid scrolls within this flex:1 space */}
          <Box sx={{ flex: 1, minHeight: 0, overflow: view === 'tableView' ? 'hidden' : 'auto' }}>
            {view === "tableView" ? (
              <MyClubsTable
                favourites={pinnedClubs ? pinnedClubs.length : 0}
                isLoading={isfetchingClubs}
                manageIsPinnedClick={manageIsPinnedClick}
              />
            ) : (
              <>
                {!isfetchingClubs && displayMyClubs.length > 0 ? (
                  <Box className="myClubCardsContainer globalClubCardsWrapper">
                    {displayMyClubs.map((club: any) => (
                      <ClubCards key={club.id} data={club} manageIsPinnedClick={manageIsPinnedClick} />
                    ))}
                  </Box>
                ) : (
                  /* Unified empty state — cards view */
                  <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '200px',
                    gap: '10px',
                  }}>
                    <Box sx={{
                      width: 44,
                      height: 44,
                      borderRadius: '50%',
                      backgroundColor: searchString ? 'rgba(224,68,68,0.08)' : `${colors.grey.dark}12`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <FontAwesomeIcon
                        icon={faMagnifyingGlass}
                        style={{ fontSize: '17px', color: searchString ? '#D94040' : colors.grey.dark, opacity: 0.6 }}
                      />
                    </Box>
                    <Typography sx={{ fontSize: '12px', color: colors.grey.dark, textAlign: 'center', opacity: 0.7, maxWidth: '180px', lineHeight: 1.5 }}>
                      {searchString
                        ? <>No clubs match <strong>"{searchString}"</strong></>
                        : 'No clubs to display'
                      }
                    </Typography>
                  </Box>
                )}
              </>
            )}
          </Box>

        </Box>
      </Box>
    </React.Fragment>
  );
};

export default MyClubsContainer;
